/**
 * MSA Comparison Map Block JavaScript
 * Handles interactive state comparison functionality
 */

import { trackStateComparison, trackDataComparisonSelection } from '../analytics';

let MsaComparisonMap = (function($) {
  
  // Selectors
  let _s = {
    container: '.wp-block-indp-msa-comparison-map',
    select1: '#msaSelect1',
    select2: '#msaSelect2',
    tags: '#msaTags',
    map: '#msaMap',
    tooltip: '#msaTooltip',
    tabs: '#msaTabs',
    tableWrap: '#msaTableWrap',
    tab: '.wp-block-indp-msa-comparison-map__tab'
  };

  // Map from SVG <g id="..."> names to state abbreviation codes
  let SVG_ID_TO_CODE = {
    Alabama:'AL',Alaska:'AK',Arizona:'AZ',Arkansas:'AR',California:'CA',Colorado:'CO',
    Connecticut:'CT',Delaware:'DE',Florida:'FL',Georgia:'GA',Hawaii:'HI',Idaho:'ID',
    Illinois:'IL',Indiana:'IN',Iowa:'IA',Kansas:'KS',Kentucky:'KY',Louisiana:'LA',
    Maine:'ME',Maryland:'MD',Massachusetts:'MA',Michigan:'MI',Minnesota:'MN',
    Mississippi:'MS',Missouri:'MO',Montana:'MT',Nebraska:'NE',Nevada:'NV',
    New_Hampshire:'NH',New_Jersey:'NJ',New_Mexico:'NM',New_York:'NY',
    North_Carolina:'NC',North_Dakota:'ND',Ohio:'OH',Oklahoma:'OK',Oregon:'OR',
    Pennsylvania:'PA',Rhode_Island:'RI',South_Carolina:'SC',South_Dakota:'SD',
    Tennessee:'TN',Texas:'TX',Utah:'UT',Vermont:'VT',Virginia:'VA',Washington:'WA',
    West_Virginia:'WV',Wisconsin:'WI',Wyoming:'WY',Washington_DC:'DC'
  };

  // State data
  let STATES = {
    AL:{n:'Alabama',f:'01'},AK:{n:'Alaska',f:'02'},AZ:{n:'Arizona',f:'04'},AR:{n:'Arkansas',f:'05'},
    CA:{n:'California',f:'06'},CO:{n:'Colorado',f:'08'},CT:{n:'Connecticut',f:'09'},DE:{n:'Delaware',f:'10'},
    FL:{n:'Florida',f:'12'},GA:{n:'Georgia',f:'13'},HI:{n:'Hawaii',f:'15'},ID:{n:'Idaho',f:'16'},
    IL:{n:'Illinois',f:'17'},IN:{n:'Indiana',f:'18'},IA:{n:'Iowa',f:'19'},KS:{n:'Kansas',f:'20'},
    KY:{n:'Kentucky',f:'21'},LA:{n:'Louisiana',f:'22'},ME:{n:'Maine',f:'23'},MD:{n:'Maryland',f:'24'},
    MA:{n:'Massachusetts',f:'25'},MI:{n:'Michigan',f:'26'},MN:{n:'Minnesota',f:'27'},MS:{n:'Mississippi',f:'28'},
    MO:{n:'Missouri',f:'29'},MT:{n:'Montana',f:'30'},NE:{n:'Nebraska',f:'31'},NV:{n:'Nevada',f:'32'},
    NH:{n:'New Hampshire',f:'33'},NJ:{n:'New Jersey',f:'34'},NM:{n:'New Mexico',f:'35'},NY:{n:'New York',f:'36'},
    NC:{n:'North Carolina',f:'37'},ND:{n:'North Dakota',f:'38'},OH:{n:'Ohio',f:'39'},OK:{n:'Oklahoma',f:'40'},
    OR:{n:'Oregon',f:'41'},PA:{n:'Pennsylvania',f:'42'},RI:{n:'Rhode Island',f:'44'},SC:{n:'South Carolina',f:'45'},
    SD:{n:'South Dakota',f:'46'},TN:{n:'Tennessee',f:'47'},TX:{n:'Texas',f:'48'},UT:{n:'Utah',f:'49'},
    VT:{n:'Vermont',f:'50'},VA:{n:'Virginia',f:'51'},WA:{n:'Washington',f:'53'},WV:{n:'West Virginia',f:'54'},
    WI:{n:'Wisconsin',f:'55'},WY:{n:'Wyoming',f:'56'},DC:{n:'District of Columbia',f:'11'}
  };

  // Static tax data
  let STATIC = {
    corporate_tax:{IN:4.9,AL:6.5,AK:9.4,AZ:4.9,AR:5.3,CA:8.84,CO:4.4,CT:7.5,DE:8.7,FL:5.5,GA:5.75,HI:6.4,ID:5.8,IA:5.5,KS:4.0,KY:5.0,LA:7.5,ME:8.93,MD:8.25,MA:8.0,MI:6.0,MN:9.8,MS:5.0,MO:4.0,MT:6.75,NE:5.58,NV:0,NH:7.5,NJ:9.0,NM:5.9,NY:7.25,NC:2.5,ND:4.31,OH:0,OK:4.0,OR:6.6,PA:8.99,RI:7.0,SC:5.0,SD:0,TN:6.5,TX:0,UT:4.65,VT:8.5,VA:6.0,WA:0,WV:6.5,WI:7.9,WY:0,DC:8.25},
    income_tax:{IN:3.05,AL:5.0,AK:0,AZ:2.5,AR:4.4,CA:13.3,CO:4.4,CT:6.99,DE:6.6,FL:0,GA:5.49,HI:11.0,ID:5.8,IA:5.7,KS:5.7,KY:4.0,LA:4.25,ME:7.15,MD:5.75,MA:5.0,MI:4.25,MN:9.85,MS:5.0,MO:4.95,MT:6.75,NE:6.64,NV:0,NH:0,NJ:10.75,NM:5.9,NY:10.9,NC:4.5,ND:2.5,OH:3.5,OK:4.75,OR:9.9,PA:3.07,RI:5.99,SC:6.5,SD:0,TN:0,TX:0,UT:4.65,VT:8.75,VA:5.75,WA:0,WV:5.12,WI:7.65,WY:0,DC:10.75},
    sales_tax:{IN:7.0,AL:4.0,AK:0,AZ:5.6,AR:6.5,CA:7.25,CO:2.9,CT:6.35,DE:0,FL:6.0,GA:4.0,HI:4.0,ID:6.0,IA:6.0,KS:6.5,KY:6.0,LA:4.45,ME:5.5,MD:6.0,MA:6.25,MI:6.0,MN:6.875,MS:7.0,MO:4.225,MT:0,NE:5.5,NV:6.85,NH:0,NJ:6.625,NM:5.125,NY:4.0,NC:4.75,ND:5.0,OH:5.75,OK:4.5,OR:0,PA:6.0,RI:7.0,SC:6.0,SD:4.5,TN:7.0,TX:6.25,UT:6.1,VT:6.0,VA:5.3,WA:6.5,WV:6.0,WI:5.0,WY:4.0,DC:6.0},
    right_to_work:{IN:true,AL:true,AK:false,AZ:true,AR:true,CA:false,CO:false,CT:false,DE:false,FL:true,GA:true,HI:false,ID:true,IA:true,KS:true,KY:true,LA:true,ME:false,MD:false,MA:false,MI:true,MN:false,MS:true,MO:false,MT:false,NE:true,NV:true,NH:false,NJ:false,NM:false,NY:false,NC:true,ND:true,OH:false,OK:true,OR:false,PA:false,RI:false,SC:true,SD:true,TN:true,TX:true,UT:true,VT:false,VA:true,WA:false,WV:true,WI:true,WY:true,DC:false}
  };

  // Categories
  let CATEGORIES = {
    business: {
      name: 'Business Costs & Economy',
      metrics: [
        {id: 'corporate_tax', name: 'Corporate Tax Rate (%)', type: 'percentage'},
        {id: 'income_tax', name: 'Income Tax Rate (%)', type: 'percentage'},
        {id: 'sales_tax', name: 'Sales Tax Rate (%)', type: 'percentage'},
        {id: 'right_to_work', name: 'Right to Work', type: 'boolean'}
      ]
    },
    population: {
      name: 'Population & Demographics',
      metrics: [
        {id: 'population', name: 'Total Population', type: 'number'},
        {id: 'median_age', name: 'Median Age', type: 'number'},
        {id: 'population_growth', name: 'Population Growth (%)', type: 'percentage'}
      ]
    },
    workforce: {
      name: 'Workforce & Education',
      metrics: [
        {id: 'labor_force', name: 'Labor Force Size', type: 'number'},
        {id: 'unemployment_rate', name: 'Unemployment Rate (%)', type: 'percentage'},
        {id: 'education_attainment', name: 'Education Attainment (%)', type: 'percentage'}
      ]
    },
    utilities: {
      name: 'Utilities & Infrastructure',
      metrics: [
        {id: 'electricity_cost', name: 'Electricity Cost ($/kWh)', type: 'decimal'},
        {id: 'gas_cost', name: 'Natural Gas Cost ($/therm)', type: 'decimal'},
        {id: 'broadband_coverage', name: 'Broadband Coverage (%)', type: 'percentage'}
      ]
    },
    quality: {
      name: 'Quality of Life',
      metrics: [
        {id: 'cost_of_living', name: 'Cost of Living Index', type: 'number'},
        {id: 'healthcare_access', name: 'Healthcare Access (%)', type: 'percentage'},
        {id: 'air_quality', name: 'Air Quality Index', type: 'number'}
      ]
    },
    rankings: {
      name: 'Rankings & Accolades',
      metrics: [
        {id: 'business_ranking', name: 'Business Climate Ranking', type: 'rank'},
        {id: 'innovation_ranking', name: 'Innovation Ranking', type: 'rank'},
        {id: 'livability_ranking', name: 'Livability Ranking', type: 'rank'}
      ]
    }
  };

  // Current selections - Indiana is always selected
  let _selectedStates = {
    indiana: 'IN', // Indiana always selected
    state1: null,  // First comparison state
    state2: null   // Second comparison state
  };

  // Flag to prevent double tracking
  let _isMapClick = false;

  // Initialize
  let _init = function() {
    _populateSelects();
    _bindEvents();
    _initMap();
    _updateComparison(); // Show initial empty state
  };

  // Populate state selects
  let _populateSelects = function() {
    $(_s.select1 + ', ' + _s.select2).each(function() {
      let $select = $(this);
      Object.keys(STATES).forEach(function(code) {
        let state = STATES[code];
        $select.append('<option value="' + code + '">' + state.n + '</option>');
      });
    });
  };

  // Bind events
  let _bindEvents = function() {
    // Select change events
    $(document).on('change', _s.select1, function() {
      _handleStateSelect(1, $(this).val());
    });

    $(document).on('change', _s.select2, function() {
      _handleStateSelect(2, $(this).val());
    });

    // Tab click events
    $(_s.container).on('click', _s.tab, function() {
      _handleTabClick($(this));
    });
  };

  // Handle state selection
  let _handleStateSelect = function(selectorNum, stateCode) {
    let key = 'state' + selectorNum;
    
    if (_selectedStates[key] === stateCode) {
      return; // Same state selected
    }

    // Prevent selecting Indiana (it's always selected)
    if (stateCode === 'IN') {
      let $select = selectorNum === 1 ? $(_s.select1) : $(_s.select2);
      $select.val('');
      return;
    }

    // Prevent selecting the same state in both comparison slots
    let otherKey = selectorNum === 1 ? 'state2' : 'state1';
    if (_selectedStates[otherKey] === stateCode) {
      // Reset current selection to prevent duplicate
      let $select = selectorNum === 1 ? $(_s.select1) : $(_s.select2);
      $select.val('');
      return;
    }

    _selectedStates[key] = stateCode;
    _updateTags();
    _updateComparison();
    _updateMapStates(); // Update map visual states
    
    // Track state comparison selection via dropdown (skip if triggered by map click)
    if (!_isMapClick && stateCode && STATES[stateCode]) {
      trackStateComparison(
        STATES[stateCode].n,
        'Dropdown ' + selectorNum
      );
    }
  };

  // Remove selected state
  let _removeSelectedState = function(key) {
    // key should be 'state1' or 'state2'
    _selectedStates[key] = null;
    
    // Clear corresponding dropdown
    let $select = key === 'state2' ? $(_s.select2) : $(_s.select1);
    $select.val('').trigger('change');
    
    _updateTags();
    _updateComparison();
    _updateMapStates();
  };

  // Update selected state tags
  let _updateTags = function() {
    let $tags = $(_s.tags);
    $tags.empty();

    // Only show comparison states, not Indiana (which is always selected)
    ['state1', 'state2'].forEach(function(key) {
      let stateCode = _selectedStates[key];
      if (stateCode && STATES[stateCode]) {
        let tagHtml = '<span class="wp-block-indp-msa-comparison-map__tag">' +
          STATES[stateCode].n +
          '<button class="wp-block-indp-msa-comparison-map__tag-remove" data-state="' + key.replace('state', '') + '">' +
          '<svg width="12" height="12" viewBox="0 0 12 12" fill="none">' +
          '<path d="M9 3l-6 6M3 3l6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>' +
          '</svg>' +
          '</button>' +
          '</span>';
        $tags.append(tagHtml);
      }
    });
    
    // Add tag remove handlers using event delegation
    // Unbind previous handlers to prevent multiple bindings
    $(_s.tags).off('click', '.wp-block-indp-msa-comparison-map__tag-remove');
    $(_s.tags).on('click', '.wp-block-indp-msa-comparison-map__tag-remove', function() {
      let stateKey = $(this).data('state');
      _removeSelectedState('state' + stateKey);
    });
  };

  // Update comparison table
  let _updateComparison = function() {
    // Show empty state if no comparison states selected at all
    if (!_selectedStates.state1 && !_selectedStates.state2) {
      _showEmptyState();
      return;
    }

    let activeCat = $(_s.tab + '.active').data('cat');
    let category = CATEGORIES[activeCat];
    
    if (!category) return;

    let tableHtml = '<table class="wp-block-indp-msa-comparison-map__table">' +
    '<thead>' +
      '<tr>' +
        '<th>' + category.name + '</th>' +
        '<th>Indiana</th>' +
        '<th>' + (_selectedStates.state1 ? STATES[_selectedStates.state1].n : 'Select State 1') + '</th>' +
        (_selectedStates.state2 ? '<th>' + STATES[_selectedStates.state2].n + '</th>' : '') +
      '</tr>' +
    '</thead>' +
    '<tbody>';

    category.metrics.forEach(function(metric) {
      let indianaVal = _getMetricValue(metric, 'IN');
      let compareVal1 = _getMetricValue(metric, _selectedStates.state1);
      let compareVal2 = _getMetricValue(metric, _selectedStates.state2);
      
      tableHtml += '<tr>' +
        '<th>' + metric.name + '</th>' +
        '<td>' + _formatValue(indianaVal, metric.type) + '</td>' +
        '<td>' + _formatValue(compareVal1, metric.type) + '</td>' +
        (_selectedStates.state2 ? '<td>' + _formatValue(compareVal2, metric.type) + '</td>' : '') +
        '</tr>';
    });

    tableHtml += '</tbody></table>';
    $(_s.tableWrap).html(tableHtml);
  };

  // Get metric value for a state
  let _getMetricValue = function(metric, stateCode) {
    // Use static data for now
    if (STATIC[metric.id] && STATIC[metric.id][stateCode] !== undefined) {
      return STATIC[metric.id][stateCode];
    }
    return null;
  };

  // Format metric value
  let _formatValue = function(value, type) {
    if (value === null || value === undefined) {
      return 'N/A';
    }

    switch (type) {
      case 'percentage':
        return value + '%';
      case 'boolean':
        return value ? 'Yes' : 'No';
      case 'decimal':
        return '$' + value.toFixed(2);
      case 'rank':
        return '#' + value;
      case 'number':
        return value.toLocaleString();
      default:
        return value;
    }
  };

  // Handle tab click
  let _handleTabClick = function($tab) {
    $(_s.container).find(_s.tab).removeClass('active');
    $tab.addClass('active');
    _updateComparison();
    
    // Track data comparison category selection
    let category = $tab.data('cat');
    if (category) {
      // Build states compared string
      let statesCompared = [];
      if (_selectedStates.state1 && STATES[_selectedStates.state1]) {
        statesCompared.push(STATES[_selectedStates.state1].n);
      }
      if (_selectedStates.state2 && STATES[_selectedStates.state2]) {
        statesCompared.push(STATES[_selectedStates.state2].n);
      }
      
      trackDataComparisonSelection(category, statesCompared.join(', '));
    }
  };

  // Handle state click on map
  let _handleStateMapClick = function(stateCode) {
    // Prevent selecting Indiana (it's always selected)
    if (stateCode === 'IN') {
      return;
    }

    // Track which slot will be filled
    let slotLabel = '';
    
    // Set flag to prevent double tracking from dropdown change event
    _isMapClick = true;
    
    // Fill first empty slot
    if (!_selectedStates.state1) {
      slotLabel = 'Map Click - Slot 1';
      $(_s.select1).val(stateCode).trigger('change');
    } else if (!_selectedStates.state2) {
      slotLabel = 'Map Click - Slot 2';
      $(_s.select2).val(stateCode).trigger('change');
    } else if (stateCode !== _selectedStates.state1 && stateCode !== _selectedStates.state2) {
      // Both slots filled, replace state1
      slotLabel = 'Map Click - Replace Slot 1';
      $(_s.select1).val(stateCode).trigger('change');
    } else if (stateCode === _selectedStates.state2) {
      // Clicking already selected state2, do nothing
      _isMapClick = false;
      return;
    } else if (stateCode === _selectedStates.state1) {
      // Clicking already selected state1, do nothing
      _isMapClick = false;
      return;
    }
    
    // Track state comparison selection via map (only if a slot was filled)
    if (slotLabel && stateCode && STATES[stateCode]) {
      trackStateComparison(
        STATES[stateCode].n,
        slotLabel
      );
    }
    
    // Reset flag after tracking
    _isMapClick = false;
  };

  // Show empty state
  let _showEmptyState = function() {
    let emptyHtml = '<div class="wp-block-indp-msa-comparison-map__empty">' +
      '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">' +
      '<path d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l5.447 2.724A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"/>' +
      '</svg>' +
      '<strong>Select a state to compare</strong>' +
      '<p>Use the dropdowns above or click a state on the map to see how Indiana compares.</p>' +
      '</div>';
    $(_s.tableWrap).html(emptyHtml);
  };

  // Initialize map
  let _initMap = function() {
    // Load the US Map SVG
    $.get('/wp-content/themes/indy-partnership-theme/build/img/US_Map.svg', function(svgData) {
      // Extract only the SVG content, not the XML document
      let svgContent = $(svgData).find('svg')[0] || svgData;
      $(_s.map).html(svgContent);
      
      // Add click handlers to state paths and circles (for DC)
      $(_s.map).find('g path, g circle').each(function() {
        let $element = $(this);
        let stateCode = null;
        
        // Check all parent groups to find state ID
        $element.parents('g').each(function() {
          let groupId = $(this).attr('id');
          if (groupId && SVG_ID_TO_CODE[groupId]) {
            stateCode = SVG_ID_TO_CODE[groupId];
            return false; // Stop searching once found
          }
        });

        if (!stateCode) return;

        if (STATES[stateCode]) {
          $element.css('cursor', 'pointer');

          // Click handler
          $element.on('click', function() {
            _handleStateMapClick(stateCode);
          });

          // Hover handlers
          $element.on('mouseenter', function() {
            $(_s.tooltip).text(STATES[stateCode].n).css('opacity', 1);
          });

          $element.on('mouseleave', function() {
            $(_s.tooltip).css('opacity', 0);
          });
        }
      });
      
      // Position tooltip to follow mouse
      $(_s.map).on('mousemove', function(e) {
        let mapOffset = $(this).offset();
        $(_s.tooltip).css({
          left: e.pageX - mapOffset.left + 10,
          top: e.pageY - mapOffset.top - 30
        });
      });
      
    }).fail(function() {
      $(_s.map).html('Map loading failed<br><small>Please check file path</small>');
    });
  };

  // Update map visual states
  let _updateMapStates = function() {
    $(_s.map).find('g').each(function() {
      let $group = $(this);
      let stateCode = null;
      
      // Check all parent groups to find state ID
      $group.parents('g').addBack().each(function() {
        let groupId = $(this).attr('id');
        if (groupId && SVG_ID_TO_CODE[groupId]) {
          stateCode = SVG_ID_TO_CODE[groupId];
          return false; // Stop searching once found
        }
      });
      
      if (!stateCode) return;
      
      // Remove all state classes
      $group.removeClass('msa-state-selected-1 msa-state-selected-2 msa-state-indiana');
      
      // Add Indiana highlight
      if (stateCode === 'IN') {
        $group.addClass('msa-state-indiana');
      }
      
      // Add comparison state classes
      if (stateCode === _selectedStates.state1) {
        $group.addClass('msa-state-selected-1');
      }
      if (stateCode === _selectedStates.state2) {
        $group.addClass('msa-state-selected-2');
      }
    });
  };

  // Public API
  return {
    init: _init
  };

})(jQuery);

export default MsaComparisonMap;
